import { Box3, Matrix4, Object3D } from "three";

/**
 * This can be used to uniformly translate the children of the given root so
 * that it appears that the origin point of the group has moved relative to
 * the axis-aligned bounding box of the object.
 *
 * Note that if you want to do this on a single Mesh object, you will need to
 * either add it to a group and apply this function to the group, or you could
 * use the setOrigin function in geometry.ts to translate the BufferGeometry
 * itself.
 */
export const setOrigin = (root: Object3D, x: number, y: number, z: number) => {
    const
        b = new Box3(),
        oldPos = root.position.clone(),
        oldRot = root.rotation.clone(),
        oldScale = root.scale.clone(),
        parent = root.parent;
        
    try {
        root.parent = null;
        root.position.set(0, 0, 0);
        root.rotation.set(0, 0, 0);
        root.scale.set(1, 1, 1);
        root.matrixWorldNeedsUpdate = true;

        b.setFromObject(root, true);

        const
            width = b.max.x - b.min.x,
            height = b.max.y - b.min.y,
            depth = b.max.z - b.min.z,
            dx = -x * width - b.min.x,
            dy = -y * height - b.min.y,
            dz = -z * depth - b.min.z;

        for(const child of root.children) {
            child.position.x += dx;
            child.position.y += dy;
            child.position.z += dz;
        }
    }
    finally {
        root.parent = parent;
        root.position.copy(oldPos);
        root.rotation.copy(oldRot);
        root.scale.copy(oldScale);
        root.matrixWorldNeedsUpdate = true;
        root.updateMatrixWorld();
    }
}
export default setOrigin;
